<template>
    <v-autocomplete :append-icon="'mdi-chevron-down'" v-bind="$attrs" v-on="$listeners">
        <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
            <slot :name="slot" v-bind="scope"></slot>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    props: {},

    data: () => ({}),

    computed: {},

    watch: {},
};
</script>
